import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import type { EditProgramaInput } from "@/lib/validaciones/editProgramaSchema";
import { toast } from "sonner";

export const useUpdatePrograma = (options?: {
  queryKey?: ReadonlyArray<unknown>;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: EditProgramaInput) => {
      const res = await axiosInstance.patch(`/programas/${data.id}`, data);
      return res.data;
    },
    onSuccess: () => {
      if (options?.queryKey) {
        queryClient.invalidateQueries({ queryKey: options.queryKey });
      } else {
        queryClient.invalidateQueries({ queryKey: ["programas"] });
      }
      toast.success("Programa actualizado exitosamente");
    },
    onError: () => {
      toast.error("Error al actualizar el programa");
    },
  });
};
